import * as types from './mutation-types';
import { AppState, ServerError, SerializedResource, TimeInfo } from '@/types';

export default {
  [types.TOGGLE_LIGHTS](state: AppState, payload: { lights?: boolean } = {}) {
    state.lights = [payload.lights, !state.lights].find(
      v => typeof v === 'boolean'
    );
  },

  [types.TOGGLE_SIDEBAR](state: AppState, payload: { sidebar?: boolean } = {}) {
    state.sidebar = [payload.sidebar, !state.sidebar].find(
      v => typeof v === 'boolean'
    );
  },

  [types.STICK_SETTING](
    state: AppState,
    payload: { setting: 'lights' | 'sidebar' }
  ) {
    if (state.stuckSettings.includes(payload.setting)) {
      return;
    }

    state.stuckSettings.push(payload.setting);
  },

  [types.UPDATE_PATH](state: AppState, payload: { path: string }) {
    state.path = payload.path.replace(/\/$/, '');
  },

  [types.LOADING](state: AppState) {
    state.loading = true;
  },

  [types.LOAD_STRUCTURE](
    state: AppState,
    payload: { data: SerializedResource }
  ) {
    state.loading = false;
    state.structure = { ...payload.data };
  },

  [types.SERVER_ERROR](state: AppState, payload: ServerError) {
    state.loading = false;
    state.error = payload;
  },

  [types.TIME_TRAVEL](state: AppState, payload: TimeInfo) {
    state.time = payload;
  },
};
